import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import api from '@/lib/api';
import { inr } from '@/lib/format';
import Loader from '@/components/common/Loader';

export function BrowseColors() {
  const [colors, setColors] = useState(null);
  useEffect(() => { api.get('/browse/colors').then((r) => setColors(r.data)).catch(() => setColors([])); }, []);
  if (!colors) return <Loader />;
  return (
    <div>
      <div className="border-b border-border bg-white"><div className="container-gaze py-8"><p className="eyebrow mb-2">Shop by Color</p><h1 className="text-3xl font-semibold sm:text-4xl">Colour your space</h1></div></div>
      <div className="container-gaze py-8">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-5">
          {colors.map((c) => (
            <Link key={c.name} to={`/shop?color=${encodeURIComponent(c.name)}`} data-testid="color-swatch-card" className="flex flex-col items-center gap-3 rounded-2xl border border-border bg-white p-6 transition hover:hairline-gold">
              <span className="h-16 w-16 rounded-full border border-black/10 shadow-inner" style={{ background: c.hex }} />
              <div className="text-center"><p className="text-sm font-semibold">{c.name}</p><p className="text-xs text-muted-foreground">{c.count} items</p></div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export function BrowseBudget() {
  const [buckets, setBuckets] = useState(null);
  useEffect(() => { api.get('/browse/budgets').then((r) => setBuckets(r.data)).catch(() => setBuckets([])); }, []);
  if (!buckets) return <Loader />;
  return (
    <div>
      <div className="border-b border-border bg-white"><div className="container-gaze py-8"><p className="eyebrow mb-2">Shop by Budget</p><h1 className="text-3xl font-semibold sm:text-4xl">Luxury for every budget</h1></div></div>
      <div className="container-gaze py-8">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {buckets.map((b) => (
            <Link key={b.key} to={`/shop?budget=${b.key}`} data-testid="budget-bucket-card" className="flex items-center justify-between rounded-2xl border border-border bg-white p-6 transition hover:hairline-gold hover:shadow-md">
              <div><p className="font-display text-2xl">{b.label}</p><p className="text-xs text-muted-foreground">{b.count} items</p></div>
              <ChevronRight className="text-muted-foreground" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
